import React from 'react';
// eslint-disable-next-line no-restricted-imports
import Banner from 'plaid-threads/Banner';

const Alert = (props) => {
  return <Banner {...props} />;
};

export default Alert;
